import React from 'react';
import { useTranslation } from 'react-i18next';
import { CButton } from '@app/components/Common';
import { View } from '@/styles/reactnative';
import { useTradeModalStore } from '../../../../../../../hooks/trade/modalStore';

const AccountDeposit = ({ bgColor, color }) => {
  const { t } = useTranslation();

  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();
  const openModal = () => {
    muatateModalStore({ ...modalStore, depositModal: true });
  };
  return (
    <CButton
      title={t('deposit')}
      onClick={() => {
        openModal();
      }}
      style={{
        border: 'none',
        background: '#2A2C2E',
        color: '#E9E9ED',
        height: '34px',
        width: '100%',
        borderRadius: 6,
        boxSizing: 'border-box',
        flex: 1,
        fontFamily: 'NanumSquareRound',
        fontWeight: 700,
        fontSize: 12,
        letterSpacing: -0.36,
      }}
    />
  );
};

export default AccountDeposit;
